// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.5 2H14.7L19 6.3V20.5C19 21.3284 18.3284 22 17.5 22H14V21H17.5C17.7761 21 18 20.7761 18 20.5V7H15.5C14.6716 7 14 6.32843 14 5.5V3H6.5C6.22386 3 6 3.22386 6 3.5V16H5V3.5C5 2.67157 5.67157 2 6.5 2ZM17.3 6L15 3.7V5.5C15 5.77614 15.2239 6 15.5 6H17.3Z" />
  <path d="M3 17.8971V17H6.52509V17.8971H5.25606V22H4.28313V17.8971H3Z" />
  <path d="M7.76146 17L8.64979 18.8382L9.55926 17H10.5674L9.1856 19.5515L10.5674 22H9.48876L8.60043 20.2721L7.69096 22H6.68278L8.06462 19.6029L6.68278 17H7.76146Z" />
  <path d="M10.7249 17.8971V17H14.25V17.8971H12.981V22H12.008V17.8971H10.7249Z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-file-txt-CdS__v4e.js.map
